(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kiva-compare-backup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kiva-compare'))
    customElements.define(
      'kiva-compare',
      class extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
          this.models = JSON.parse(this.querySelector('[data-models]').textContent).filter(
            (p) => p.title && ['sauna', 'ice'].includes(p.category)
          );
          this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
          this.selected = new Set();
          this.category = 'sauna';
          this.query = '';
          this.differences = false;
          this.dialog = this.querySelector('dialog');
          this.querySelectorAll('[data-category]').forEach((b) =>
            b.addEventListener('click', () => {
              if (this.category === b.dataset.category) return;
              this.category = b.dataset.category;
              this.query = '';
              this.querySelector('[data-search]').value = '';
              this.selected.clear();
              this.render();
            })
          );
          this.querySelector('[data-search]').addEventListener('input', (e) => {
            this.query = e.target.value.toLowerCase();
            this.picker();
          });
          this.querySelector('[data-differences]').addEventListener('change', (e) => {
            this.differences = e.target.checked;
            this.table();
          });
          this.querySelector('[data-open]').addEventListener('click', () => {
            this.dialog.showModal();
            this.querySelector('[data-search]').focus();
          });
          this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
          this.dialog.addEventListener('close', () => this.querySelector('[data-open]').focus());
          this.dialog.addEventListener('click', (e) => {
            const r = this.dialog.getBoundingClientRect();
            if (e.target === this.dialog && (e.clientX < r.left || e.clientX > r.right)) this.dialog.close();
          });
          this.render();
        }
        el(tag, text) {
          const e = document.createElement(tag);
          if (text !== undefined) e.textContent = text;
          return e;
        }
        value(p, key) {
          const v = p.fields[key];
          return v === true
            ? this.labels.yes
            : v === false
            ? this.labels.no
            : v === null || v === undefined || String(v).trim() === ''
            ? this.labels.unknown
            : String(v).replaceAll('—', '-');
        }
        toggle(id, checked) {
          const model = this.models.find((p) => p.id === id);
          if (!model || model.category !== this.category) return false;
          if (checked) {
            if (this.selected.size >= 4) return false;
            this.selected.add(id);
          } else this.selected.delete(id);
          return true;
        }
        price(p) {
          const box = this.el('p');
          box.className = 'kiva-compare__price';
          const value = this.el('span', p.price);
          if (p.comparePrice) {
            value.className = 'kiva-compare__price-sale';
            value.prepend(this.hidden(this.labels.sale_price + ' '));
            const old = this.el('s', p.comparePrice);
            old.prepend(this.hidden(this.labels.regular_price + ' '));
            box.append(value, old);
          } else box.append(value);
          return box;
        }
        hidden(text) {
          const e = this.el('span', text);
          e.className = 'visually-hidden';
          return e;
        }
        render() {
          this.querySelectorAll('[data-category]').forEach((b) =>
            b.setAttribute('aria-pressed', String(b.dataset.category === this.category))
          );
          this.querySelector('[data-heading]').textContent = this.labels[this.category + '_heading'];
          this.querySelector('[data-intro]').textContent = this.labels[this.category + '_intro'].replace(
            '[count]',
            String(this.models.filter((p) => p.category === this.category).length)
          );
          this.picker();
          this.table();
        }
        picker() {
          const root = this.querySelector('[data-picker]');
          root.replaceChildren();
          const results = this.models.filter(
            (p) => p.category === this.category && p.title.toLowerCase().includes(this.query)
          );
          results.forEach((p) => {
            const label = this.el('label');
            if (p.image) {
              const img = this.el('img');
              img.src = p.image;
              img.alt = '';
              img.loading = 'lazy';
              label.append(img);
            } else label.append(this.el('span'));
            const copy = this.el('span'),
              name = this.el('span', p.title);
            name.className = 'kiva-compare__picker-name';
            copy.append(name, this.price(p));
            const input = this.el('input');
            input.type = 'checkbox';
            input.value = p.id;
            input.checked = this.selected.has(p.id);
            input.disabled = !input.checked && this.selected.size >= 4;
            input.setAttribute('aria-label', p.title);
            input.addEventListener('change', () => {
              this.toggle(p.id, input.checked);
              this.render();
              Array.from(root.querySelectorAll('input'))
                .find((x) => x.value === p.id)
                ?.focus();
            });
            label.append(copy, input);
            root.append(label);
          });
          if (!results.length) root.append(this.el('p', this.labels.no_results));
          const status =
            this.selected.size +
            '/4 ' +
            this.labels.selected +
            (this.selected.size === 4 ? ' · ' + this.labels.limit : '');
          this.querySelector('[data-status]').textContent = status;
          this.querySelector('[data-drawer-status]').textContent = status;
        }
        table() {
          const root = this.querySelector('[data-table]');
          root.replaceChildren();
          const models = this.models.filter((p) => this.selected.has(p.id));
          if (!models.length) {
            const empty = this.el('p', this.labels.empty);
            empty.className = 'kiva-compare__empty';
            root.append(empty);
            return;
          }
          const table = this.el('table');
          table.style.setProperty('--kiva-models', models.length);
          const cap = this.el('caption', this.labels[this.category + '_heading']);
          cap.className = 'visually-hidden';
          table.append(cap);
          const head = this.el('thead'),
            row = this.el('tr'),
            count = this.el('th', this.selected.size + '/4 ' + this.labels.selected);
          count.scope = 'col';
          row.append(count);
          models.forEach((p) => {
            const cell = this.el('th');
            cell.scope = 'col';
            const card = this.el('div');
            card.className = 'kiva-compare__card';
            const remove = this.el('button', this.labels.remove);
            remove.type = 'button';
            remove.className = 'kiva-compare__remove';
            remove.dataset.remove = p.id;
            remove.setAttribute('aria-label', this.labels.remove + ' ' + p.title);
            remove.addEventListener('click', () => {
              this.selected.delete(p.id);
              this.render();
              (this.querySelector('[data-remove]') || this.querySelector('[data-open]')).focus();
            });
            card.append(remove);
            if (p.image) {
              const img = this.el('img');
              img.src = p.image;
              img.alt = p.title;
              img.loading = 'lazy';
              card.append(img);
            }
            const parts = p.category === 'sauna' ? p.title.match(/^(.*?\bPerson)\s*(.*)$/i) : null;
            card.append(this.el('h2', parts ? parts[1] : p.title));
            const type = this.el('p', parts ? parts[2] : '');
            type.className = 'kiva-compare__type';
            card.append(type, this.price(p));
            const a = this.el('a', this.labels.view);
            a.href = p.url;
            a.className = 'button button-secondary';
            card.append(a);
            cell.append(card);
            row.append(cell);
          });
          head.append(row);
          table.append(head);
          const body = this.el('tbody');
          const groups = [
            [
              'space',
              this.category === 'sauna'
                ? ['capacity', 'wood', 'placement', 'seating', 'standing']
                : ['water', 'depth', 'fill_offset', 'water_depth'],
            ],
            ['heat', this.category === 'sauna' ? ['technology', 'heater', 'temperature', 'power'] : ['temperature']],
            ['controls', this.category === 'sauna' ? ['wifi'] : ['wifi', 'plumbing']],
            ['assurance', this.category === 'sauna' ? ['warranty'] : ['warranty']],
          ];
          groups.forEach(([group, keys]) => {
            const rows = [];
            keys.forEach((key) => {
              const values = models.map((p) => this.value(p, key)),
                different = new Set(values).size > 1;
              if (this.differences && !different) return;
              const tr = this.el('tr'),
                th = this.el('th', this.labels[key]);
              th.scope = 'row';
              tr.append(th);
              if (different) {
                tr.dataset.different = '';
                const note = this.el('small', this.labels.different_row);
                note.className = 'kiva-compare__row-note';
                th.append(note);
              }
              values.forEach((v) => tr.append(this.el('td', v)));
              rows.push(tr);
            });
            if (rows.length) {
              const tr = this.el('tr'),
                th = this.el('th', this.labels[group]);
              tr.className = 'kiva-compare__group';
              th.colSpan = models.length + 1;
              th.scope = 'colgroup';
              tr.append(th);
              body.append(tr, ...rows);
            }
          });
          table.append(body);
          root.append(table);
        }
      }
    );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiva-compare"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kiva-compare'))
    customElements.define(
      'kiva-compare',
      class extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
          this.models = JSON.parse(this.querySelector('[data-models]').textContent).filter(
            (p) => p.title && ['sauna', 'ice'].includes(p.category)
          );
          this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
          this.selected = new Set();
          this.category = 'sauna';
          this.query = '';
          this.differences = false;
          this.dialog = this.querySelector('dialog');
          this.querySelectorAll('[data-category]').forEach((b) =>
            b.addEventListener('click', () => {
              if (this.category === b.dataset.category) return;
              this.category = b.dataset.category;
              this.query = '';
              this.querySelector('[data-search]').value = '';
              this.selected.clear();
              this.render();
            })
          );
          this.querySelector('[data-search]').addEventListener('input', (e) => {
            this.query = e.target.value.toLowerCase();
            this.picker();
          });
          this.querySelector('[data-differences]').addEventListener('change', (e) => {
            this.differences = e.target.checked;
            this.table();
          });
          this.querySelector('[data-open]').addEventListener('click', () => {
            this.dialog.showModal();
            this.querySelector('[data-search]').focus();
          });
          this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
          this.dialog.addEventListener('close', () => this.querySelector('[data-open]').focus());
          this.dialog.addEventListener('click', (e) => {
            const r = this.dialog.getBoundingClientRect();
            if (e.target === this.dialog && (e.clientX < r.left || e.clientX > r.right)) this.dialog.close();
          });
          this.render();
        }
        el(tag, text) {
          const e = document.createElement(tag);
          if (text !== undefined) e.textContent = text;
          return e;
        }
        value(p, key) {
          const v = p.fields[key];
          return v === true
            ? this.labels.yes
            : v === false
            ? this.labels.no
            : v === null || v === undefined || String(v).trim() === ''
            ? this.labels.unknown
            : String(v).replaceAll('—', '-');
        }
        toggle(id, checked) {
          const model = this.models.find((p) => p.id === id);
          if (!model || model.category !== this.category) return false;
          if (checked) {
            if (this.selected.size >= 4) return false;
            this.selected.add(id);
          } else this.selected.delete(id);
          return true;
        }
        price(p) {
          const box = this.el('p');
          box.className = 'kiva-compare__price';
          const value = this.el('span', p.price);
          if (p.comparePrice) {
            value.className = 'kiva-compare__price-sale';
            value.prepend(this.hidden(this.labels.sale_price + ' '));
            const old = this.el('s', p.comparePrice);
            old.prepend(this.hidden(this.labels.regular_price + ' '));
            box.append(value, old);
          } else box.append(value);
          return box;
        }
        hidden(text) {
          const e = this.el('span', text);
          e.className = 'visually-hidden';
          return e;
        }
         splitWarranty(text) {
          return String(text)
            .replace(/<br\s*\/?>/gi, '\n')
            .replace(/\r/g, '')
            .replace(/([.!?])\s+(?=[A-Z0-9])/g, '$1\n')
            .replace(/,\s+(?=\d)/g, '\n')
            .replace(/\s+(?:&|\+|and)\s+(?=\d)/gi, '\n')
            .split(/\n+|\s*[•·;|]\s*/)
            .map((part) => part.replace(/^[\s\-–*•]+/, '').replace(/[\s.,;]+$/, '').trim())
            .filter(Boolean);
        }
        splitList(text) {
          return String(text)
            .replace(/<br\s*\/?>/gi, '\n')
            .replace(/\r/g, '')
            .split(/\n+|\s*[•·;|]\s*|\s+[+\/&]\s+|,(?!\d)(?![^()]*\))/)
            .map((part) => part.replace(/^[\s\-–*•]+/, '').replace(/[\s.,;]+$/, '').trim())
            .filter(Boolean);
        }
        cell(key, value) {
          const td = this.el('td');
          const lists = {
            warranty: { split: 'splitWarranty', min: 1 },
            heater: { split: 'splitList', min: 2 },
            technology: { split: 'splitList', min: 2 }
          };
          const rule = lists[key];
          if (rule && value !== this.labels.unknown) {
            const items = this[rule.split](value);
            if (items.length >= rule.min) {
              const list = this.el('ul');
              list.className = 'kiva-compare__list';
              items.forEach((item) => list.append(this.el('li', item)));
              td.append(list);
              return td;
            }
          }
          td.textContent = value;
          return td;
        }
        equalize(root) {
          const run = () => {
            ['.kiva-compare__card h2', '.kiva-compare__type'].forEach((selector) => {
              const items = Array.from(root.querySelectorAll(selector));
              items.forEach((item) => (item.style.minHeight = ''));
              const tallest = Math.max(0, ...items.map((item) => item.offsetHeight));
              if (tallest) items.forEach((item) => (item.style.minHeight = tallest + 'px'));
            });
          };
          run();
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if ('ResizeObserver' in window) {
            let width = root.offsetWidth;
            this.resizeObserver = new ResizeObserver(() => {
              if (root.offsetWidth === width) return;
              width = root.offsetWidth;
              run();
            });
            this.resizeObserver.observe(root);
          }
        }
        /* Swipe indicator, edge fade and the mobile pinned model bar. */
        scrollAids(root, table, models) {
          const dots = this.querySelector('[data-swipe-dots]');
          const track = this.querySelector('[data-pinned-track]');
          dots.replaceChildren();
          track.replaceChildren();
          // The first header cell is the "x/4 selected" label column, not a model.
          this.columns = table ? Array.from(table.querySelectorAll('thead th')).slice(1) : [];
          this.columns.forEach((th, i) => {
            const name = th.querySelector('h2')?.textContent || models[i].title;
            const dot = this.el('button');
            dot.type = 'button';
            dot.className = 'kiva-compare__dot';
            dot.setAttribute('aria-label', this.labels.show_model.replace('[model]', name));
            dot.addEventListener('click', () => this.scrollToColumn(i));
            dots.append(dot);
            const cell = this.el('div');
            cell.className = 'kiva-compare__pinned-cell';
            cell.append(this.el('span', name), this.price(models[i]));
            track.append(cell);
          });
          if (!this.scroller) {
            this.scroller = root;
            this.mobile = window.matchMedia('(max-width: 749px)');
            let queued = false;
            const update = () => {
              if (queued) return;
              queued = true;
              requestAnimationFrame(() => {
                queued = false;
                this.updateScrollAids();
              });
            };
            root.addEventListener('scroll', update, { passive: true });
            window.addEventListener('scroll', update, { passive: true });
            window.addEventListener('resize', () => this.layoutScrollAids(), { passive: true });
          }
          this.layoutScrollAids();
        }
        layoutScrollAids() {
          const table = this.scroller.querySelector('table');
          const track = this.querySelector('[data-pinned-track]');
          if (table) {
            const tableLeft = table.getBoundingClientRect().left;
            track.style.width = table.offsetWidth + 'px';
            Array.from(track.children).forEach((cell, i) => {
              const rect = this.columns[i].getBoundingClientRect();
              cell.style.left = rect.left - tableLeft + 'px';
              cell.style.width = rect.width + 'px';
            });
          }
          this.updateScrollAids();
        }
        updateScrollAids() {
          const root = this.scroller;
          const swipe = this.querySelector('[data-swipe]');
          const overflow = root.scrollWidth > root.clientWidth + 1;
          const atEnd = root.scrollLeft + root.clientWidth >= root.scrollWidth - 1;
          root.toggleAttribute('data-more', overflow && !atEnd);
          swipe.hidden = !overflow || !this.columns.length;
          if (!swipe.hidden) {
            const view = root.getBoundingClientRect();
            const visible = this.columns.map((th) => {
              const rect = th.getBoundingClientRect();
              return Math.min(rect.right, view.right) - Math.max(rect.left, view.left) >= rect.width * 0.6;
            });
            const first = visible.indexOf(true);
            const last = visible.lastIndexOf(true);
            const range = first === last ? String(first + 1) : first + 1 + '–' + (last + 1);
            this.querySelector('[data-swipe-text]').textContent =
              first < 0 ? '' : this.labels.showing.replace('[range]', range).replace('[count]', this.columns.length);
            Array.from(this.querySelector('[data-swipe-dots]').children).forEach((dot, i) =>
              dot.toggleAttribute('data-active', visible[i])
            );
          }
          this.querySelector('[data-pinned-track]').style.transform = 'translateX(' + -root.scrollLeft + 'px)';
          const pinned = this.querySelector('[data-pinned]');
          const head = root.querySelector('thead');
          let show = false;
          if (head && this.mobile.matches) {
            const top = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
            const barHeight = pinned.firstElementChild.offsetHeight;
            show =
              head.getBoundingClientRect().bottom < top + 8 &&
              root.getBoundingClientRect().bottom > top + barHeight + 48;
          }
          pinned.toggleAttribute('data-visible', show);
        }
        scrollToColumn(index) {
          const root = this.scroller;
          const label = root.querySelector('thead th');
          // On wider screens the label column is pinned on the left; scroll the model in beside it.
          const pinnedWidth = label && getComputedStyle(label).display !== 'none' ? label.offsetWidth : 0;
          const offset =
            this.columns[index].getBoundingClientRect().left - root.getBoundingClientRect().left - pinnedWidth;
          const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          root.scrollBy({ left: offset, behavior: smooth ? 'smooth' : 'auto' });
        }
        render() {
          this.querySelectorAll('[data-category]').forEach((b) =>
            b.setAttribute('aria-pressed', String(b.dataset.category === this.category))
          );
          this.querySelector('[data-heading]').textContent = this.labels[this.category + '_heading'];
          this.querySelector('[data-intro]').textContent = this.labels[this.category + '_intro'].replace(
            '[count]',
            String(this.models.filter((p) => p.category === this.category).length)
          );
          this.picker();
          this.table();
        }
        picker() {
          const root = this.querySelector('[data-picker]');
          root.replaceChildren();
          const results = this.models.filter(
            (p) => p.category === this.category && p.title.toLowerCase().includes(this.query)
          );
          results.forEach((p) => {
            const label = this.el('label');
            if (p.image) {
              const img = this.el('img');
              img.src = p.image;
              img.alt = '';
              img.loading = 'lazy';
              label.append(img);
            } else label.append(this.el('span'));
            const copy = this.el('span'),
              name = this.el('span', p.title);
            name.className = 'kiva-compare__picker-name';
            copy.append(name, this.price(p));
            const input = this.el('input');
            input.type = 'checkbox';
            input.value = p.id;
            input.checked = this.selected.has(p.id);
            input.disabled = !input.checked && this.selected.size >= 4;
            input.setAttribute('aria-label', p.title);
            input.addEventListener('change', () => {
              this.toggle(p.id, input.checked);
              this.render();
              Array.from(root.querySelectorAll('input'))
                .find((x) => x.value === p.id)
                ?.focus();
            });
            label.append(copy, input);
            root.append(label);
          });
          if (!results.length) root.append(this.el('p', this.labels.no_results));
          const status =
            this.selected.size +
            '/4 ' +
            this.labels.selected +
            (this.selected.size === 4 ? ' · ' + this.labels.limit : '');
          this.querySelector('[data-status]').textContent = status;
          this.querySelector('[data-drawer-status]').textContent = status;
        }
        table() {
          const root = this.querySelector('[data-table]');
          root.replaceChildren();
          const models = this.models.filter((p) => this.selected.has(p.id));
          if (!models.length) {
            const empty = this.el('p', this.labels.empty);
            empty.className = 'kiva-compare__empty';
            root.append(empty);
            this.scrollAids(root, null, []);
            return;
          }
          const table = this.el('table');
          table.style.setProperty('--kiva-models', models.length);
          const cap = this.el('caption', this.labels[this.category + '_heading']);
          cap.className = 'visually-hidden';
          table.append(cap);
          const head = this.el('thead'),
            row = this.el('tr'),
            count = this.el('th', this.selected.size + '/4 ' + this.labels.selected);
          count.scope = 'col';
          row.append(count);
          models.forEach((p) => {
            const cell = this.el('th');
            cell.scope = 'col';
            const card = this.el('div');
            card.className = 'kiva-compare__card';
            const remove = this.el('button', this.labels.remove);
            remove.type = 'button';
            remove.className = 'kiva-compare__remove';
            remove.dataset.remove = p.id;
            remove.setAttribute('aria-label', this.labels.remove + ' ' + p.title);
            remove.addEventListener('click', () => {
              this.selected.delete(p.id);
              this.render();
              (this.querySelector('[data-remove]') || this.querySelector('[data-open]')).focus();
            });
            card.append(remove);
            if (p.image) {
              const img = this.el('img');
              img.src = p.image;
              img.alt = p.title;
              img.loading = 'lazy';
              card.append(img);
            }
            const parts = p.category === 'sauna' ? p.title.match(/^(.*?\bPerson)\s*(.*)$/i) : null;
            card.append(this.el('h2', parts ? parts[1] : p.title));
            const type = this.el('p', parts ? parts[2] : '');
            type.className = 'kiva-compare__type';
            card.append(type, this.price(p));
            const a = this.el('a', this.labels.view);
            a.href = p.url;
            a.className = 'button button-secondary';
            card.append(a);
            cell.append(card);
            row.append(cell);
          });
          head.append(row);
          table.append(head);
          const body = this.el('tbody');
          const groups = [
            [
              'space',
              this.category === 'sauna'
                ? ['capacity', 'wood', 'placement', 'seating', 'standing']
                : ['water', 'depth', 'fill_offset', 'water_depth'],
            ],
            ['dimensions', this.category === 'sauna' ? ['exterior', 'interior'] : []],
            ['heat', this.category === 'sauna' ? ['technology', 'heater', 'temperature', 'voltage', 'power'] : ['temperature']],
            ['controls', this.category === 'sauna' ? ['wifi'] : ['wifi', 'plumbing']],
            ['assurance', this.category === 'sauna' ? ['warranty'] : ['warranty']],
          ];
          groups.forEach(([group, keys]) => {
            const rows = [];
            keys.forEach((key) => {
              const values = models.map((p) => this.value(p, key)),
                different = new Set(values).size > 1;
              if (this.differences && !different) return;
              const tr = this.el('tr'),
                th = this.el('th', this.labels[key]);
              th.scope = 'row';
              tr.append(th);
              if (different) {
                tr.dataset.different = '';
                const note = this.el('small', this.labels.different_row);
                note.className = 'kiva-compare__row-note';
                th.append(note);
              }
              values.forEach((v) => tr.append(this.cell(key, v)));
              rows.push(tr);
            });
            if (rows.length) {
              const tr = this.el('tr'),
                th = this.el('th', this.labels[group]);
              tr.className = 'kiva-compare__group';
              th.colSpan = models.length + 1;
              th.scope = 'colgroup';
              tr.append(th);
              body.append(tr, ...rows);
            }
          });
          table.append(body);
          root.append(table);
          this.equalize(root);
          this.scrollAids(root, table, models);
        }
      }
    );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiva-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kiva-contact'))
    customElements.define(
      'kiva-contact',
      class extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
          const topic = this.querySelector('[data-topic]'),
            phone = this.querySelector('[data-phone]'),
            labels = JSON.parse(this.querySelector('[data-contact-labels]').textContent);
          const update = () => {
            phone.required = topic.value === 'Expert callback request';
            this.querySelector('[data-phone-label]').textContent = phone.required
              ? labels.phoneRequired
              : labels.phoneOptional;
          };
          topic.addEventListener('change', update);
          this.querySelector('[data-callback]').addEventListener('click', () => {
            topic.value = 'Expert callback request';
            update();
            requestAnimationFrame(() => topic.focus({ preventScroll: true }));
          });
          this.querySelector('[data-chat]').addEventListener('click', (e) => {
            if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
              e.preventDefault();
              window.GorgiasChat.open();
            } else {
              this.querySelector('[data-chat-status]').hidden = false;
            }
          });
          update();
        }
      }
    );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiva-hawks"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kiva-hawks'))customElements.define('kiva-hawks',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const b=this.querySelector('button');b.addEventListener('click',()=>{const paused=this.toggleAttribute('paused');b.setAttribute('aria-pressed',String(paused));b.textContent=paused?b.dataset.play:b.dataset.pause})}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiva-home-campaigns"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('kiva-home-campaigns'))customElements.define('kiva-home-campaigns',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const track=this.querySelector('.kv-campaigns__track'),buttons=[...this.querySelectorAll('[data-slide]')];buttons.forEach((b,i)=>b.addEventListener('click',()=>track.scrollTo({left:i*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})));let frame;track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{const index=Math.round(track.scrollLeft/track.clientWidth);buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)))})});this.addEventListener('shopify:block:select',e=>{const slides=[...track.children],i=slides.indexOf(e.target);if(i>=0)track.scrollTo({left:i*track.clientWidth,behavior:'instant'})})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiva-showrooms"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('kiva-showroom-filter'))customElements.define('kiva-showroom-filter',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.cards=Array.from(this.querySelectorAll('.kiva-showrooms article'));
  const root=this.querySelector('[data-state-buttons]');
  const states=Array.from(new Set(this.cards.map(card=>card.dataset.state.trim()).filter(Boolean))).sort((a,b)=>a.localeCompare(b));
  if(!root.querySelector('button'))['',...states].forEach(state=>{const button=document.createElement('button');button.type='button';button.textContent=state||this.dataset.all;button.dataset.state=state;button.setAttribute('aria-pressed',String(!state));root.append(button)});
  root.querySelectorAll('button').forEach(button=>button.addEventListener('click',()=>this.filter(button.dataset.state)));
  this.querySelector('fieldset').hidden=false;this.filter('');
  this.addEventListener('shopify:block:select',()=>this.filter(''));
 }
 filter(state){
  this.cards.forEach(card=>{card.hidden=Boolean(state&&card.dataset.state.trim()!==state)});
  this.querySelectorAll('[data-state-buttons] button').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.state===state)));
  const count=this.cards.filter(card=>!card.hidden).length;
  this.querySelector('[data-state-count]').textContent=(count===1?this.dataset.countOne:this.dataset.countOther).replace('[count]',String(count));
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-main-page"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('kiva-policy-accordions'))customElements.define('kiva-policy-accordions',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const nodes=Array.from(this.childNodes);const tag=nodes.some(n=>n.nodeName==='H2')?'H2':'H3';let body=null;nodes.forEach(n=>{if(n.nodeName===tag){const detail=document.createElement('details'),summary=document.createElement('summary');while(n.firstChild)summary.append(n.firstChild);body=document.createElement('div');body.className='kiva-help__answer';detail.append(summary,body);n.replaceWith(detail)}else if(body){body.append(n)}});const reveal=()=>{if(location.hash){let el=document.getElementById(decodeURIComponent(location.hash.slice(1)))||document.getElementsByName(decodeURIComponent(location.hash.slice(1)))[0];if(el&&this.contains(el)){const d=el.closest('details');if(d)d.open=true}}};reveal();window.addEventListener('hashchange',reveal)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
